var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 7.44 7.44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #e95c28;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 3.72,
    cy: 3.72,
    r: 3.72
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1.68,3.07c.08.05.16.1.25.15.55.33,1.1.67,1.64,1,.1.06.2.06.3,0,.61-.38,1.23-.75,1.84-1.13.01,0,.03-.02.05-.03,0,.02,0,.03,0,.04,0,.5,0,1,0,1.5,0,.36-.26.62-.62.62-.95,0-1.9,0-2.85,0-.34,0-.58-.25-.61-.52,0,0,0,0,0-.01,0-.54,0-1.08,0-1.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1.7,2.69c.04-.23.27-.44.5-.46.04,0,.09,0,.13,0,.93,0,1.87,0,2.8,0,.27,0,.46.12.57.36.05.1.05.1-.05.16-.63.39-1.27.77-1.9,1.16-.03.02-.05.02-.07,0-.65-.4-1.3-.79-1.95-1.19-.01,0-.02-.02-.04-.02Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/Mail Icon.ce5918b7f13568f8c7352eca6365901f.svg";
export { ForwardRef as ReactComponent };